<div *ngIf="project">
  <h2 mat-dialog-title>{{ project.name }}</h2>
  <div class="counts">
    <span title="Stars"
      ><img src="../../assets/stars.svg" alt="stars" />{{
        project.stargazers_count
      }}</span
    >
    <span title="Forks"
      ><img src="../../assets/fork.svg" alt="stars" />{{
        project.forks_count
      }}</span
    >
    <span title="Watchers"
      ><img src="../../assets/eye.svg" alt="stars" />{{
        project.subscribers_count
      }}</span
    >
  </div>
  <mat-dialog-content
    ><p>{{ project.description }}</p>
    <mat-chip-list aria-label="Languages">
      <mat-chip
        color="primary"
        *ngFor="let language of languages | keyvalue"
        selected
        >{{ language.key }}</mat-chip
      >
    </mat-chip-list>
    <app-pie
      *ngIf="languagesData.length"
      id="repo"
      [data]="languagesData"
    ></app-pie>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close (click)="onNoClick()">Close</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  </mat-dialog-actions>
</div>
<mat-progress-bar *ngIf="!project" mode="indeterminate"></mat-progress-bar>
